import React from 'react';
import axios from "../../../../../containers/api";
import {Button, CardBody, Row, CardTitle} from "reactstrap";
import {Colxx, Separator} from "../../../../../components/common/CustomBootstrap";
import {Table} from "../../../../../components/table/Table";
import {showCatchError} from "../../../../../helpers/Utils";

class ShowTransportationCompanyHalls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LoadHallToEdit: this.props.LoadHallToEdit,
            TransportationCompanies: this.props.TransportationCompanies,
            LoadHallTransportationCompanies: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({
                LoadHallToEdit: this.props.LoadHallToEdit,
                TransportationCompanies: this.props.TransportationCompanies
            });
        }
    }

    componentDidMount() {
        this.GetTransportationCompanyHall();
    }

    GetTransportationCompanyHall = () => {
        this.props.showSpinner();
        axios.get('/api/v1/transportation-company-halls/GetByLoadHallId?Id=' + this.state.LoadHallToEdit.loadHallId)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({LoadHallTransportationCompanies: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
            });
    };

    DeleteByTransportationCompanyId = (TransportationCompanyId) => {
        this.props.showSpinner();
        let model = {
            Item1: TransportationCompanyId
        };
        axios.post('/api/v1/transportation-company-halls/DeleteByTransportationCompanyId', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.GetTransportationCompanyHall()
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    AddTransportationCompanyHall = (TransportationCompanyId) => {
        let model = {
            TransportationCompanyId: TransportationCompanyId,
            loadHallId: this.state.LoadHallToEdit.loadHallId
        }

        this.props.showSpinner();
        axios.post('/api/v1/transportation-company-halls/AddTransportationCompanyHall', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.GetTransportationCompanyHall();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody>
                        <CardTitle>
                            لیست نمایندگی‌های
                            {" "}
                            {this.state.LoadHallToEdit && this.state.LoadHallToEdit.name}
                        </CardTitle>

                        <Table
                            tableHeaders={[
                                "شناسه",
                                "نام کامل",
                                "کد ملی",
                                "موبایل",
                                "حذف",
                            ]}

                            tableRow={this.state.LoadHallTransportationCompanies !== null ? this.state.LoadHallTransportationCompanies : []}

                            tableData={[
                                TransportationCompany => {
                                    return "TC" + TransportationCompany.transportationCompanyNationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyName;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyNationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyMobile;
                                },
                                TransportationCompany => {
                                    return (
                                        <Button outline color="danger" size="sm"
                                            onClick={() => this.DeleteByTransportationCompanyId(TransportationCompany.id)}>
                                            حذف
                                        </Button>
                                    )
                                }
                            ]}
                        />

                        <Separator className="my-5" />

                        <CardTitle>لیست کل نمایندگی‌ها</CardTitle>

                        <Table
                            tableHeaders={[
                                "شناسه",
                                "نام کامل",
                                "کد ملی",
                                "موبایل",
                                "افزودن",
                            ]}

                            tableRow={this.state.TransportationCompanies !== null ? this.state.TransportationCompanies : []}

                            tableData={[
                                TransportationCompany => {
                                    return "TC" + TransportationCompany.nationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyName;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.nationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.mobile;
                                },
                                TransportationCompany => {
                                    return (
                                        <Button outline color="success" size="sm"
                                            onClick={() => this.AddTransportationCompanyHall(TransportationCompany.transportationCompanyId)}>
                                            افزودن
                                        </Button>
                                    )
                                }
                            ]}
                        />
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default ShowTransportationCompanyHalls;